export default __webpack_public_path__ + "static/media/ic_products.ba2d5e62.svg";